<template>
    <AppLayout>
        <div class="container px-3 py-4 mx-auto md:px-6 lg:px-8">
            <p class="mb-2 text-2xl font-bold">
                {{ $t('LBL_CART') }}
            </p>

            <div>
                <!-- Cart Items -->
                <div
                    v-if="$page.props.cartItems.length"
                    class="flex flex-col lg:flex-row space-x-4"
                >
                    <!-- Group by wholesaler -->
                    <div class="w-full">
                        <div
                            v-for="(wholesaler, index) in wholesalersInvolved"
                            :key="'wholesaler-' + wholesaler.id"
                            class="mb-4 space-y-2 bg-white rounded w-full"
                        >
                            <div>
                                <div
                                    class="flex flex-col justify-between p-2 font-semibold border-b lg:flex-row lg:items-center"
                                >
                                    <div>
                                        {{ wholesaler.name }}
                                    </div>
                                    <div
                                        v-if="!isValidCartList(itemsOfWholesaler(wholesaler))"
                                        class="text-red-400"
                                    >
                                        Please clear the payment for previous bill.
                                    </div>
                                    <!-- <div
                                    v-if="!hasValidCreditWithAllWholesalersInvolved && !hasValidCreditWithWholesaler(wholesaler)"
                                    class="text-red-400"
                                >
                                    You don't have credit with this wholesaler.
                                </div> -->
                                </div>

                                <!-- Cart Products  -->
                                <div
                                    v-for="cartItem in itemsOfWholesaler(wholesaler)"
                                    :key="'cart-item-' + cartItem.id"
                                    class="flex flex-col gap-6 p-3 md:flex-row"
                                >
                                    <div class="sm:w-1/3 md:w-1/5">
                                        <img
                                            class="object-contain w-full cursor-pointer h-28"
                                            :src="
                                                cartItem.product.images.length
                                                    ? cartItem.product.images[0].image_path
                                                    : defaultImage
                                            "
                                            alt="avatar"
                                            @click="
                                                goto('products.show', {
                                                    dummy: `${convertToKebabCase(
                                                        cartItem.product.brand.name,
                                                    )}-${convertToKebabCase(cartItem.product.name)}`,
                                                    product: cartItem.product_slug,
                                                })
                                            "
                                        />
                                    </div>
                                    <div class="flex flex-col sm:1/3 md:w-1/2">
                                        <p
                                            class="cursor-pointer"
                                            @click="
                                                goto('products.show', {
                                                    dummy: `${convertToKebabCase(
                                                        cartItem.product.brand.name,
                                                    )}-${convertToKebabCase(cartItem.product.name)}`,
                                                    product: cartItem.product_slug,
                                                })
                                            "
                                        >
                                            {{ cartItem.product.name }}
                                        </p>
                                        <p class="text-sm text-gray-400">
                                            {{ cartItem.product.brand && cartItem.product.brand.name }}
                                        </p>
                                    </div>
                                    <div class="flex justify-between md:justify-start md:flex-col sm:1/3 md:w-1/4">
                                        <div class="md:mb-6">
                                            <p class="font-semibold">
                                                {{ config(common.currency, cartItem.product.owner) }}
                                                {{ parseFloat(cartItem.product.price).toFixed(2) }}
                                            </p>
                                            Per Item
                                        </div>
                                    </div>
                                    <div class="md:w-1/4">
                                        <div class="flex flex-row justify-between items-center md:mb-6">
                                            <p class="relative text-xl font-semibold text-green-600">
                                                <LoadingData :is-loading="isProcessing(cartItem)" />
                                                {{ config(common.currency, cartItem.product.owner) }}
                                                {{ parseFloat(cartItem.product.price * cartItem.qty).toFixed(2) }}
                                            </p>

                                            <div @click="removeFromCart(cartItem)">
                                                <DeleteIcon
                                                    class="w-3 text-red-800 cursor-pointer fill-current md:w-4"
                                                />
                                            </div>
                                        </div>

                                        <CounterComponent
                                            :debounce="2000"
                                            :current-count="cartItem.qty"
                                            :max="cartItem.product.available_stock"
                                            class="w-full"
                                            @beforeChange="addToProcessing(cartItem)"
                                            @countChanged="countChanged($event, cartItem)"
                                        />

                                        <div :class="!isPurchasedQuantityValid(cartItem) ? 'text-red-500' : ''">
                                            Available Stock : {{ availableStock(cartItem.product) }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Order Summary -- it is always false and does not rendered  -->
                            <div
                                v-if="false"
                                class="w-full lg:border-l-8 border-gray-50 lg:w-1/3"
                            >
                                <div class="p-4 bg-white rounded">
                                    <p class="my-2 font-semibold text-md">Order Summary</p>

                                    <div class="flex items-center justify-between text-gray-500">
                                        <p>Subtotal ({{ totalQuantity(itemsOfWholesaler(wholesaler)) }} items)</p>
                                        <div class="relative">
                                            <LoadingData :is-loading="!!itemsBeingProcessed.length" />
                                            <p>
                                                {{ config(common.currency) }}
                                                {{ totalSum(itemsOfWholesaler(wholesaler)) }}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <!-- promocode block -->
                                <div>
                                    <div class="flex my-3">
                                        <t-input
                                            v-model="promocode[index]"
                                            placeholder="Enter Promo Code"
                                        />
                                        <button
                                            class="px-6 py-2 ml-2 text-white bg-green-500 rounded"
                                            @click="checkPromocode(index)"
                                        >
                                            Apply
                                        </button>
                                    </div>

                                    <div
                                        v-if="promoDetails[index]"
                                        class="my-2 border rounded"
                                    >
                                        <div class="p-2 bg-gray-200">
                                            Applicable for
                                            <span class="font-bold">{{ applicableProducts(index) }}</span>
                                            owned by
                                            <span class="font-bold">{{ promoOwner[index].name }}</span>
                                        </div>
                                        <div class="p-2">
                                            <div class="flex justify-between">
                                                <div>Discount ({{ promoDetails[index].data.rewardType }})</div>
                                                <div>{{ promoDetails[index].reward }}</div>
                                            </div>

                                            <div
                                                v-if="promoDetails[0]"
                                                class="my-2 border rounded"
                                            >
                                                <!-- <div class="p-2 bg-gray-200">
                                        Applicable for <span class="font-bold">{{ applicableProducts(0) }}</span>
                                        owned by
                                        <span class="font-bold">{{ promoOwner[0].name }}</span>
                                    </div> -->
                                                <div class="p-2">
                                                    <div class="flex justify-between">
                                                        <div>Discount ({{ promoDetails[0].data.rewardType }})</div>
                                                        <div>{{ promoDetails[0].reward }}</div>
                                                    </div>

                                                    <div class="flex justify-between">
                                                        <div>Discount Amount</div>
                                                        <div>
                                                            {{ discountAmount(0).toFixed(2) }}
                                                        </div>
                                                    </div>

                                                    <div class="flex justify-between">
                                                        <div>Total after vat and discount</div>
                                                        <div>{{ totalSumWithVatAndDiscount(0).toFixed(2) }}</div>
                                                    </div>

                                                    <div class="flex justify-between">
                                                        <div>Expires</div>
                                                        <div>{{ promoDetails[0].expires_at | fromNow }}</div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div
                                                v-if="
                                                    totalSum(itemsOfWholesaler(wholesaler)) !=
                                                    totalSumWithVat(itemsOfWholesaler(wholesaler))
                                                "
                                                class="flex justify-between"
                                            >
                                                <p>Vat Percent ({{ config(common.vat) }}%)</p>
                                                <div>
                                                    {{ config(common.currency) }}
                                                    {{
                                                        (
                                                            totalSumWithVat(itemsOfWholesaler(wholesaler)) -
                                                            totalSum(itemsOfWholesaler(wholesaler))
                                                        ).toFixed(2)
                                                    }}
                                                </div>
                                            </div>

                                            <!-- Total -->
                                            <div class="flex justify-between">
                                                <p
                                                    v-if="
                                                        totalSum(itemsOfWholesaler(wholesaler)) ==
                                                        totalSumWithVat(itemsOfWholesaler(wholesaler))
                                                    "
                                                >
                                                    Total
                                                </p>
                                                <p v-else>Total with VAT</p>
                                                <div class="relative">
                                                    <LoadingData :is-loading="!!itemsBeingProcessed.length" />
                                                    <p>
                                                        {{ config(common.currency) }}
                                                        {{ totalSumWithVat(itemsOfWholesaler(wholesaler)) }}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            v-if="
                                                requiredCashOnDelivery(index) > 0 && paymentMethod[index] === 'Charge'
                                            "
                                            class="text-green-400"
                                        >
                                            You have to make the payment of amount TT$
                                            {{ requiredCashOnDelivery(index).toFixed(2) }} on delivery as it will not be
                                            coverd by your credit balance.
                                        </div>
                                    </div>

                                    <!-- Payment Method -->
                                    <div class="my-4">
                                        <p class="font-semibold text-md">Payment Method</p>
                                        <t-radio-group
                                            v-model="paymentMethod[index]"
                                            :disabled="!hasValidCreditWithWholesaler(wholesaler)"
                                            :classes="{
                                                groupWrapper: 'flex justify-around items-center',
                                                label: 'ml-2 text-gray-700 uppercase text-sm font-semibold',
                                                input: 'text-blue-500 transition duration-100 ease-in-out border-gray-300 shadow-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 focus:ring-offset-0 disabled:opacity-50 disabled:cursor-not-allowed',
                                            }"
                                            :options="['COD', 'Charge']"
                                        />
                                    </div>
                                </div>

                                <!-- <div v-if="requiredCashOnDelivery(index) > 0 && paymentMethod[index] === 'Charge'"
                                    class="text-green-400">
                                    You have to make the payment of amount TT$ {{
                                    requiredCashOnDelivery(index).toFixed(2) }} on delivery as it will not be coverd by
                                    your credit balance.
                                </div> -->

                                <!-- Payment Method -->
                                <div class="my-4">
                                    <p class="font-semibold text-md">Payment Method</p>
                                    <t-radio-group
                                        v-model="paymentMethod[index]"
                                        :disabled="!hasValidCreditWithWholesaler(wholesaler)"
                                        :classes="{
                                            groupWrapper: 'flex justify-around items-center',
                                            label: 'ml-2 text-gray-700 uppercase text-sm font-semibold',
                                            input: 'text-blue-500 transition duration-100 ease-in-out border-gray-300 shadow-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 focus:ring-offset-0 disabled:opacity-50 disabled:cursor-not-allowed',
                                        }"
                                        :options="['COD', 'Charge']"
                                    />
                                </div>

                                <div class="my-2">
                                    <div
                                        class="text-sm font-semibold text-right text-green-500 cursor-pointer"
                                        @click="showNote = !showNote"
                                        v-text="showNote ? 'Cancel Note' : 'Add Note'"
                                    />
                                    <t-textarea
                                        v-if="showNote"
                                        v-model="notes[0]"
                                        placeholder="Your Message"
                                        class="mb-3"
                                    />
                                </div>

                                <button
                                    v-if="isValidCartList($page.props.cartItems)"
                                    :disabled="!!itemsBeingProcessed.length"
                                    class="w-full py-2 text-center text-white bg-green-500 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                                    @click="purchaseAll()"
                                >
                                    Place Order
                                </button>
                                <button
                                    v-else
                                    disabled
                                    class="w-full py-2 text-center text-white bg-green-500 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                                >
                                    Place Order
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- Order Summary  -->
                    <div class="w-full lg:w-1/3">
                        <div class="p-4 bg-white rounded flex flex-col space-y-4">
                            <p class="font-semibold text-md">Order Summary</p>

                            <div class="flex items-center justify-between text-gray-500">
                                <p>Subtotal ({{ totalQuantity(allCartItems()) }} items)</p>
                                <div class="relative">
                                    <LoadingData :is-loading="!!itemsBeingProcessed.length" />
                                    <p>{{ config(common.currency) }} {{ totalSum(allCartItems()) }}</p>
                                </div>
                            </div>

                            <div
                                v-if="totalSum(allCartItems()) != totalSumWithVat(allCartItems())"
                                class="flex justify-between"
                            >
                                <p>Vat Percent ({{ config(common.vat) }}%)</p>
                                <div>
                                    {{ config(common.currency) }}
                                    {{ (totalSumWithVat(allCartItems()) - totalSum(allCartItems())).toFixed(2) }}
                                </div>
                            </div>

                            <!-- Total -->
                            <div class="flex justify-between">
                                <p v-if="totalSum(allCartItems()) == totalSumWithVat(allCartItems())">Total</p>
                                <p v-else>Total with VAT</p>
                                <div class="relative">
                                    <LoadingData :is-loading="!!itemsBeingProcessed.length" />
                                    <p>
                                        {{ config(common.currency) }}
                                        {{ totalSumWithVat(allCartItems()) }}
                                    </p>
                                </div>
                            </div>

                            <!-- Payment Method  -->
                            <div>
                                <p class="font-semibold text-md">Payment Method</p>

                                <t-radio-group
                                    v-model="paymentMethod[0]"
                                    :disabled="!(hasValidCreditWithAllWholesalersInvolved || creditStatus)"
                                    :classes="{
                                        groupWrapper: 'flex justify-around items-center',
                                        label: 'ml-2 text-gray-700 uppercase text-sm font-semibold',
                                        input: 'text-blue-500 transition duration-100 ease-in-out border-gray-300 shadow-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 focus:ring-offset-0 disabled:opacity-50 disabled:cursor-not-allowed',
                                    }"
                                    :options="['COD', 'Charge']"
                                />

                                <!-- Displaying message if no valid credit is available -->
                                <!-- <div v-if="!hasValidCreditWithAllWholesalersInvolved" class="text-red-400">
                                    You dont have enough credit for wholesalers involved.
                                </div> -->
                            </div>

                            <div>
                                <div
                                    class="font-semibold text-right text-green-500 text-sm cursor-pointer"
                                    @click="showNote = !showNote"
                                    v-text="showNote ? 'Cancel Note' : 'Add Note'"
                                />
                                <t-textarea
                                    v-if="showNote"
                                    v-model="notes[0]"
                                    placeholder="Your Message"
                                />
                            </div>

                            <div v-if="isSalesperson">
                                <Multiselect
                                    v-model="selectedRetailer"
                                    :options="assignedRetailers"
                                    :multiple="false"
                                    :close-on-select="true"
                                    placeholder="Pick Retailer"
                                    label="name"
                                    track-by="name"
                                    @input="onRetailerChange"
                                />
                            </div>

                            <button
                                v-if="
                                    isValidCartList($page.props.cartItems) &&
                                    (isSalesperson ? selectedRetailer != null : selectedRetailer == null)
                                "
                                :disabled="!!itemsBeingProcessed.length"
                                class="w-full py-2 text-center text-white bg-green-500 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                                @click="purchaseAll()"
                            >
                                Place Order
                            </button>
                            <button
                                v-else
                                disabled
                                class="w-full py-2 text-center text-white bg-green-500 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                Place Order
                            </button>
                        </div>
                    </div>
                </div>

                <div
                    v-else
                    class="text-2xl text-center text-gray-400 my-32"
                >
                    No products in your cart.
                </div>
            </div>
        </div>
    </AppLayout>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import AppLayout from '../Layouts/AppLayout.vue';
    import CounterComponent from '../Components/CounterComponent.vue';
    import LoadingData from '../Components/LoadingData.vue';
    import DeleteIcon from '../Components/Icons/DeleteIcon.vue';
    import common from '../common';

    export default {
        name: 'ProductCart',

        components: {
            AppLayout,
            CounterComponent,
            LoadingData,
            DeleteIcon,
            Multiselect,
        },

        props: {
            user: {
                type: Object,
                required: true,
            },
            assignedRetailers: {
                type: Array,
                default: null,
            },
        },

        data() {
            return {
                common,
                itemsBeingProcessed: [],
                showNote: false,

                paymentMethod: [],
                promocode: [],
                notes: [],

                promoDetails: [],
                promoOwner: [],

                selectedRetailer: null,
                creditStatus: false,
            };
        },

        computed: {
            defaultImage() {
                return `${process.env.MIX_SENTRY_DSN_PUBLIC}/storage/default/default.png`;
            },

            wholesalersInvolvedIds() {
                return this.wholesalersInvolved.map((wholesaler) => wholesaler.id);
            },

            wholesalersInvolved() {
                const wholesalersInvolved = [];
                this.$page.props.cartItems.forEach((cartItem) => {
                    if (
                        !wholesalersInvolved.find(
                            (involvedWholesaler) => involvedWholesaler.id === cartItem.product.owner.id,
                        )
                    ) {
                        wholesalersInvolved.push(cartItem.product.owner);
                    }
                });
                return wholesalersInvolved;
            },

            hasValidCreditWithAllWholesalersInvolved() {
                let status = true;

                this.wholesalersInvolvedIds.forEach((wholesalerId) => {
                    const creditOfWholesaler = this.user.credit.find(
                        (eachCredit) => parseInt(eachCredit.wholesaler_id) === parseInt(wholesalerId),
                    );

                    if (creditOfWholesaler) {
                        if (parseFloat(creditOfWholesaler.credit_balance) <= 0) {
                            status = false;
                        }
                    } else {
                        status = false;
                    }
                });

                this.creditStatus = status;
                return status;
            },
        },

        mounted() {
            this.wholesalersInvolved.forEach(() => {
                this.paymentMethod.push('COD');
                this.promocode.push(null);
                this.notes.push(null);
                this.promoDetails.push(null);
                this.promoOwner.push(null);
            });
        },

        methods: {
            hasValidCreditWithWholesaler(wholesaler) {
                let status = true;
                const creditOfWholesaler = this.user.credit.find(
                    (eachCredit) => parseInt(eachCredit.wholesaler_id) === parseInt(wholesaler.id),
                );
                if (creditOfWholesaler) {
                    if (parseFloat(creditOfWholesaler.credit_balance) <= 0) {
                        status = false;
                    }
                } else {
                    status = false;
                }
                return status;
            },

            onRetailerChange(selected) {
                console.log('Retailer selected:', selected);

                let status = true;
                this.wholesalersInvolvedIds.forEach((wholesalerId) => {
                    console.log('wholesalerId selected:', wholesalerId);

                    // console.log("wholesaler ID", selected.credit.find((eachCredit) =>
                    //     parseInt(eachCredit.wholesaler_id) === parseInt(wholesalerId)));

                    // console.log("selected", selected.credit.find(
                    //     (eachCredit) => eachCredit.wholesaler_id == 3
                    // ));

                    const creditOfWholesaler =
                        selected != null
                            ? selected.credit.find(
                                  (eachCredit) => parseInt(eachCredit.wholesaler_id) === parseInt(wholesalerId),
                              )
                            : false;

                    console.log('creditOfWholesaler:', creditOfWholesaler);
                    if (creditOfWholesaler) {
                        if (parseFloat(creditOfWholesaler.credit_balance) <= 0) {
                            status = false;
                        }
                    } else {
                        status = false;
                    }
                });

                console.log('status:', status);
                this.creditStatus = status;

                console.log('creditStatus:', this.creditStatus);
            },

            totalSumWithVat(itemsOfWholesalerInCart) {
                let totalSumWithVat = 0;
                itemsOfWholesalerInCart.forEach((cartItem) => {
                    const vatPercent = cartItem.product.owner.kyc.accept_vat
                        ? parseInt(this.config(common.vat, cartItem.product.owner)) / 100
                        : 0;
                    totalSumWithVat +=
                        cartItem.product.price * cartItem.qty + vatPercent * (cartItem.product.price * cartItem.qty);
                });
                return totalSumWithVat;
            },

            totalSumWithVatForAllCartItems() {
                let total = 0;
                this.wholesalersInvolved.forEach((wholesaler) => {
                    total += this.totalSumWithVat(this.itemsOfWholesaler(wholesaler));
                });
                return total;
            },

            totalQuantity(itemsOfWholesalerInCart) {
                let totalQuantity = 0;
                itemsOfWholesalerInCart.forEach((cartItem) => {
                    totalQuantity += cartItem.qty;
                });
                return totalQuantity;
            },

            totalSum(itemsOfWholesalerInCart) {
                let totalSum = 0;
                itemsOfWholesalerInCart.forEach((cartItem) => {
                    totalSum += parseFloat(cartItem.product.price) * cartItem.qty;
                });
                return totalSum.toFixed(2);
            },

            countChanged(count, cartItem) {
                console.log(count);
                this.$inertia.post(
                    route('cartItems.update', cartItem.id),
                    { qty: count.quantity },
                    {
                        onSuccess: () => {
                            this.itemsBeingProcessed = this.itemsBeingProcessed.filter(
                                (item) => item.id !== cartItem.id,
                            );
                        },
                    },
                );
            },

            applicableProducts(index) {
                if (this.promoDetails[index] && this.promoDetails[index].data.product_id) {
                    return this.$page.props.cartItems.find(
                        (cartItem) => cartItem.product.id === this.promoDetails[index].data.product_id,
                    ).product.name;
                }
                return 'All Products';
            },

            discountAmount(index) {
                if (this.promoDetails[index]) {
                    if (this.promoDetails[index].data.rewardType === 'currency') {
                        return parseFloat(this.promoDetails[index].reward);
                    }

                    if (this.promoDetails[index].data.product_id) {
                        const cartItemEligibleForDiscount = this.$page.props.cartItems.find(
                            (cartItem) => cartItem.product.id === this.promoDetails[index].data.product_id,
                        );
                        return (
                            (this.promoDetails[index].reward / 100) *
                            (cartItemEligibleForDiscount.product.price * cartItemEligibleForDiscount.qty)
                        );
                    }
                    return (
                        (this.promoDetails[index].reward *
                            this.totalSum(this.itemsOfWholesaler(this.wholesalersInvolved[index]))) /
                        100
                    );
                }
                return 0;
            },

            totalSumWithVatAndDiscount(index) {
                return (
                    this.totalSumWithVat(this.itemsOfWholesaler(this.wholesalersInvolved[index])) -
                    this.discountAmount(index)
                );
            },

            requiredCashOnDelivery(index) {
                const creditWithWholesaler = this.user.credit.find(
                    (eachCredit) => parseInt(eachCredit.wholesaler_id) === parseInt(this.wholesalersInvolved[index].id),
                );
                if (creditWithWholesaler) {
                    return this.totalSumWithVatAndDiscount(index) - creditWithWholesaler.credit_balance;
                }
                return this.totalSumWithVatAndDiscount(index);
            },

            addToProcessing(cartItem) {
                this.itemsBeingProcessed.push(cartItem);
            },

            isProcessing(cartItem) {
                return !!this.itemsBeingProcessed.find((item) => item.id === cartItem.id);
            },

            removeFromCart(cartItem) {
                this.$inertia.delete(route('cartItems.delete', cartItem.id), { preserveScroll: true });
            },

            checkPromocode(index) {
                if (this.promocode[index]) {
                    this.$axios.get(route('promocodes.check', this.promocode[index])).then((res) => {
                        this.$set(this.promoDetails, index, res.data.promocode);
                        this.$set(this.promoOwner, index, res.data.promoOwner);
                    });
                }
            },

            purchase(index) {
                const payload = {};
                if (this.promocode[index]) {
                    payload.promocode = this.promocode[index];
                }
                if (this.notes[index]) {
                    payload.notes = this.notes[index];
                }
                payload.payment_method = this.paymentMethod[index];
                payload.wholesaler_id = this.wholesalersInvolved[index].id;
                this.$inertia.post(route('transactions.store'), payload);
            },

            purchaseAll() {
                const payload = {};
                if (this.isSalesperson) {
                    payload.retailerId = this.selectedRetailer.id;
                }
                payload.promocode = this.promocode[0];
                payload.notes = this.notes[0];
                payload.payment_method = this.paymentMethod[0];
                this.$inertia.post(route('transactions.store'), payload);
            },

            itemsOfWholesaler(wholesaler) {
                return this.$page.props.cartItems.filter((cartItem) => cartItem.product.owner.id === wholesaler.id);
            },

            allCartItems() {
                return this.$page.props.cartItems;
            },

            isPurchasedQuantityValid(cartItem) {
                if (
                    parseInt(cartItem.qty) > 0 &&
                    parseInt(cartItem.qty) <= parseInt(cartItem.product.available_stock)
                ) {
                    return true;
                }
                return false;
            },

            isCartItemValid(cartItem) {
                if (
                    parseInt(cartItem.qty) > 0 &&
                    parseInt(cartItem.qty) <= parseInt(cartItem.product.available_stock)
                ) {
                    if (this.authUserCanPurchaseProduct(cartItem.product)) {
                        return true;
                    }
                    return false;
                }
                return false;
            },

            isValidCartList(itemsOfWholesalerInCart) {
                let cartStatus = true;
                itemsOfWholesalerInCart.forEach((cartItem) => {
                    if (!this.isCartItemValid(cartItem)) {
                        cartStatus = false;
                    }
                });
                return cartStatus;
            },

            availableStock(product) {
                if (product.available_stock === 0) {
                    return 'Out Of Stock.';
                }

                return product.available_stock < 10000 ? product.available_stock : '10K+';
            },
        },
    };
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
